import { render, staticRenderFns } from "./ChecklistContainer.vue?vue&type=template&id=a12f2f28&"
import script from "./ChecklistContainer.vue?vue&type=script&lang=js&"
export * from "./ChecklistContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports